module.exports = __webpack_public_path__ + "static/img/send_feedback.5e97f2d3.svg";